<script>
import { mapGetters } from 'vuex';
import MentionBox from '../mentions/MentionBox.vue';

export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace'],
  computed: {
    ...mapGetters({
      cannedMessages: 'getCannedResponses',
      currentUserRole: 'getCurrentRole',
    }),
    currentAccountPermissions() {
      const { accounts = [] } = this.$store.getters.getCurrentUser || {};
      const currentAccount =
        accounts.find(a => a.id === this.$store.getters.getCurrentAccountId) ||
        {};
      return currentAccount.permissions || [];
    },
    isAdmin() {
      const userType = this.$store.getters.getCurrentUser?.type;
      return (
        this.currentUserRole === 'administrator' ||
        userType === 'SuperAdmin' ||
        this.currentAccountPermissions.includes('administrator') ||
        this.currentAccountPermissions.includes('canned_manage')
      );
    },
    items() {
      const search = (this.searchKey || '')
        .trim()
        .toLowerCase()
        .replace(/^\//, '');
      return this.cannedMessages
        .filter(cannedMessage => {
          if (!search) return true;
          const shortCode = (cannedMessage.short_code || '').toLowerCase();
          const content = (cannedMessage.content || '').toLowerCase();
          return shortCode.includes(search) || content.includes(search);
        })
        .map(cannedMessage => ({
          label: cannedMessage.short_code,
          key: cannedMessage.short_code,
          description: cannedMessage.content,
        }));
    },
  },
  watch: {
    searchKey() {
      this.fetchCannedResponses();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  methods: {
    fetchCannedResponses() {
      this.$store.dispatch('getCannedResponse', {
        searchKey: this.searchKey,
        manage: this.isAdmin,
      });
    },
    handleMentionClick(item = {}) {
      this.$emit('replace', item.description);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  />
</template>
